const fetchConfig = {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
    }
};
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

onSubmitHandler(evt) {
    evt.preventDefault(); // Prevent the form's default action (page reload)
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return; // Prevent multiple submissions

    this.handleErrorMessage(); // Handle error if necessary

    this.submitButton.setAttribute('aria-disabled', true); // Disable the button to prevent multiple clicks
    this.submitButton.classList.add('loading'); // Show loading state

    const formData = new FormData(this.form); // Collect form data

    // Create a plain object for JSON payload
    const data = {
        id: formData.get('id'), // The variant ID from the hidden input
        quantity: formData.get('quantity'), // The quantity from the input
    };

    // Check if the form data has the necessary fields
    if (!data.id || !data.quantity) {
        console.error("Error: Missing variant ID or quantity.");
        return;
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(data), // Send the data object instead of FormData
    })
    .then(response => response.json())
    .then(response => {
        console.log("Product added to cart:", response);
        // Optionally: Update the cart UI or redirect to the cart page
        window.location.href = '/cart';  // Redirect to the cart page
    })
    .catch(error => {
        console.error("Error:", error);
        this.handleErrorMessage("Error adding product to cart.");
    })
    .finally(() => {
        this.submitButton.classList.remove('loading'); // Remove loading state
        this.submitButton.removeAttribute('aria-disabled'); // Enable the button again
    });
}

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".quantity-selector").forEach(selector => {
        let minusButton = selector.querySelector(".quantity-button.minus");
        let plusButton = selector.querySelector(".quantity-button.plus");
        let quantityInput = selector.querySelector(".quantity-input");
        let variantSelect = document.querySelector("select[name='id']"); // Variant dropdown

        let minQuantity = parseInt(quantityInput.getAttribute("min"), 10) || 1;

function updateMaxQuantity() {
    let selectedVariant = document.querySelector("input[name='Size']:checked"); // Ensure correct selector

    if (!selectedVariant) {
        console.error("❌ No variant selected.");
        return;
    }

    let maxQuantity = selectedVariant.getAttribute("data-inventory-quantity"); // Corrected attribute
    if (!maxQuantity || isNaN(maxQuantity)) {
        console.error("❌ Invalid inventory quantity:", maxQuantity);
        return;
    }

    let quantityInput = document.querySelector(".quantity-input");
    if (quantityInput) {
        quantityInput.setAttribute("max", maxQuantity); // Set the correct max value
        console.log(`🔄 Max Quantity Updated: ${maxQuantity}`);

        // Reset quantity if it exceeds the new max
        if (parseInt(quantityInput.value, 10) > parseInt(maxQuantity, 10)) {
            quantityInput.value = maxQuantity;
            console.log(`⚠️ Quantity reset to max: ${maxQuantity}`);
        }
    } else {
        console.error("❌ Quantity input field not found.");
    }
}

document.querySelectorAll("input[name='Size']").forEach(input => {
    input.addEventListener("change", function () {
        let selectedVariantId = this.getAttribute("data-variant-id");
        let selectedInventory = this.getAttribute("data-inventory-quantity");

        console.log(`✅ Variant Updated: ${selectedVariantId}, Inventory: ${selectedInventory}`);

        // Update max quantity dynamically
        updateMaxQuantity();
    });
});

// Run on page load too, in case a variant is already selected
document.addEventListener("DOMContentLoaded", updateMaxQuantity);

        // Increase Quantity
        plusButton.addEventListener("click", function () {
            let currentQuantity = parseInt(quantityInput.value, 10);
            let maxQuantity = parseInt(quantityInput.getAttribute("max"), 10);

            console.log("Current Quantity (Increase):", currentQuantity);
            console.log("Max Quantity (Increase):", maxQuantity);

            if (currentQuantity < maxQuantity) {
                quantityInput.value = currentQuantity + 1;
                updateCartQuantity(quantityInput.value);
                console.log("Updated Quantity (Increase):", quantityInput.value); // Log to console
            } else {
                console.log(`Cannot increase. Max quantity of ${maxQuantity} reached.`);
                alert(`You have reached the maximum stock of ${maxQuantity}!`);
            }
        });

        // Decrease Quantity
        minusButton.addEventListener("click", function () {
            let currentQuantity = parseInt(quantityInput.value, 10);
            if (currentQuantity > minQuantity) {
                quantityInput.value = currentQuantity - 1;
                updateCartQuantity(quantityInput.value);
                console.log("Updated Quantity (Decrease):", quantityInput.value); // Log to console

                // Enable the plus button again when quantity is decreased
                plusButton.disabled = false;
                console.log("Plus button enabled after decrease");
            }
        });

        // Update quantity in Add to Cart form
        function updateCartQuantity(quantity) {
            let cartForm = document.querySelector("form[action='/cart/add']");
            if (cartForm) {
                let cartQuantityInput = cartForm.querySelector("input[name='quantity']");
                if (cartQuantityInput) {
                    cartQuantityInput.value = quantity;
                }
            }
        }

    });
});


document.addEventListener("DOMContentLoaded", function () {
    function waitForElement(selector, callback) {
        const element = document.querySelector(selector);
        if (element) {
            callback(element);
        } else {
            setTimeout(() => waitForElement(selector, callback), 100);
        }
    }

    function setupBuyNowButton(button) {
        console.log("✅ Buy It Now Button Found & Ready");

        button.addEventListener("click", function (e) {
            e.preventDefault();
            console.log("🛒 Buy It Now button clicked!");

            // Find the selected variant dynamically
            let selectedVariant = document.querySelector("input[name='Size']:checked");
            let quantityInput = document.querySelector(".quantity-input");

            if (!selectedVariant) {
                console.error("❌ No variant selected.");
                return;
            }

            let variantId = selectedVariant.getAttribute("data-variant-id");
            let quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

            console.log(`✅ Selected Variant ID: ${variantId}`);
            console.log(`✅ Selected Quantity: ${quantity}`);

            if (!variantId || isNaN(quantity)) {
                console.error("❌ Missing variant or quantity.");
                return;
            }

            // Add item to cart
            fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: variantId, quantity: quantity }),
            })
            .then(response => response.json())
            .then(response => {
                console.log("✅ Item added to cart:", response);
                
                // Redirect to checkout after adding item
                window.location.href = "/checkout";
            })
            .catch(error => {
                console.error("❌ Error adding variant to cart:", error);
            });
        });
    }

    // Attach event to Buy It Now button
    waitForElement("#buyItNowButton", setupBuyNowButton);
});


document.addEventListener("DOMContentLoaded", function () {
    const productImages = document.querySelectorAll(".product__media-item img");

    productImages.forEach(image => {
        image.addEventListener("click", function () {
            const modal = document.querySelector(".product-modal"); 
            if (modal) {
                modal.classList.add("open");
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const addToCartButton = document.getElementById("addToCartButton");

    if (addToCartButton) {
        addToCartButton.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent default form submission

            // Get the selected variant ID
            const variantId = document.querySelector('#selected-variant-id').value; 

            // Get the quantity from the quantity input
            const quantity = document.querySelector('.quantity-input').value; 

            // Debugging: log the variant ID and quantity
            console.log("Variant ID:", variantId);
            console.log("Quantity:", quantity);

            // Ensure variant ID and quantity are present
            if (!variantId || !quantity) {
                console.error("Variant ID or quantity is missing");
                return;
            }

            // AJAX request to add the item to the cart
            fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id: variantId,  // The variant ID
                    quantity: quantity // The quantity selected
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log("Item added to cart:", data);
                window.location.href = '/cart';  // Redirect to the cart page
            })
            .catch(error => {
                console.error("Error adding item to cart:", error);
            });
        });
    }
});
